import { dashboardPath } from "../path";

export const reportsPath = `${dashboardPath}/reports`;

// export const linkedinReportsPath = `${reportsPath}/linkedin`;
// export const emailReportsPath = `${reportsPath}/email`;
